// import { useContext, useState } from "react";
// import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// import PropTypes from "prop-types";
// import { version } from "../../version";

// import {
//   Collapse,
//   DropdownMenu,
//   DropdownItem,
//   UncontrolledDropdown,
//   DropdownToggle,
//   Form,
//   Input,
//   InputGroupAddon,
//   InputGroupText,
//   InputGroup,
//   Media,
//   NavbarBrand,
//   Navbar,
//   NavItem,
//   NavLink,
//   Nav,
//   Container,
//   Row,
//   Col,
// } from "reactstrap";
// import { AuthContext } from "../../context/AuthContext";

// const Sidebar = (props: any) => {
//   const { handleLogout } = useContext(AuthContext);
//   const [collapseOpen, setCollapseOpen] = useState(false);

//   const toggleCollapse = () => {
//     setCollapseOpen((data: any) => !data);
//   };
//   const closeCollapse = (name: string) => {
//     if (name === "Sair") {
//       handleLogout();
//     }
//     setCollapseOpen(false);
//   };
//   const createLinks = (routes: any) => {
//     return routes.map((prop: any, key: number) => {
//       return (
//         <NavItem key={key}>
//           <NavLink
//             to={prop.layout + prop.path}
//             tag={NavLinkRRD}
//             onClick={() => closeCollapse(prop.name)}
//           >
//             <i className={prop.icon} />
//             {prop.name}
//           </NavLink>
//         </NavItem>
//       );
//     });
//   };

//   const { routes, logo } = props;
//   let navbarBrandProps;
//   if (logo && logo.innerLink) {
//     navbarBrandProps = {
//       to: logo.innerLink,
//       tag: Link,
//     };
//   } else if (logo && logo.outterLink) {
//     navbarBrandProps = {
//       href: logo.outterLink,
//       target: "_blank",
//     };
//   }

//   return (
//     <Navbar
//       className="navbar-vertical fixed-left navbar-light bg-white"
//       expand="md"
//       id="sidenav-main"
//     >
//       <Container fluid>
//         {/* Toggler */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           onClick={toggleCollapse}
//         >
//           <span className="navbar-toggler-icon" />
//         </button>
//         {/* Brand */}
//         {logo ? (
//           <NavbarBrand className="pt-0" {...navbarBrandProps}>
//             <img
//               style={{ width: "100%" }}
//               alt={logo.imgAlt}
//               src={logo.imgSrc}
//             />
//           </NavbarBrand>
//         ) : null}
//         {/* User */}
//         {/* <Nav className="align-items-center d-md-none">
//           <UncontrolledDropdown nav>
//             <DropdownToggle nav className="nav-link-icon">
//               <i className="ni ni-bell-55" />
//             </DropdownToggle>
//             <DropdownMenu
//               aria-labelledby="navbar-default_dropdown_1"
//               className="dropdown-menu-arrow"
//               right
//             >
//               <DropdownItem>Action</DropdownItem>
//               <DropdownItem>Another action</DropdownItem>
//               <DropdownItem divider />
//               <DropdownItem>Something else here</DropdownItem>
//             </DropdownMenu>
//           </UncontrolledDropdown>
//           <UncontrolledDropdown nav>
//             <DropdownToggle nav>
//               <Media className="align-items-center">
//                 <span className="avatar avatar-sm rounded-circle">
//                   <img
//                     alt="..."
//                     src={require("../../assets/img/theme/team-1-800x800.jpg")}
//                   />
//                 </span>
//               </Media>
//             </DropdownToggle>
//             <DropdownMenu className="dropdown-menu-arrow" right>
//               <DropdownItem className="noti-title" header tag="div">
//                 <h6 className="text-overflow m-0">Bem vindo!</h6>
//               </DropdownItem> */}
//         {/* <DropdownItem to="/admin/user-profile" tag={Link}>
//                 <i className="ni ni-single-02" />
//                 <span>My profile</span>
//               </DropdownItem>
//               <DropdownItem to="/admin/user-profile" tag={Link}>
//                 <i className="ni ni-settings-gear-65" />
//                 <span>Settings</span>
//               </DropdownItem>
//               <DropdownItem to="/admin/user-profile" tag={Link}>
//                 <i className="ni ni-calendar-grid-58" />
//                 <span>Activity</span>
//               </DropdownItem>
//               <DropdownItem to="/admin/user-profile" tag={Link}>
//                 <i className="ni ni-support-16" />
//                 <span>Support</span>
//               </DropdownItem> */}
//         {/* <DropdownItem divider /> */}
//         {/* <DropdownItem href="#pablo" onClick={() => handleLogout()}>
//                 <i className="ni ni-user-run" />
//                 <span>Sair</span>
//               </DropdownItem>
//             </DropdownMenu>
//           </UncontrolledDropdown>
//         </Nav> */}
//         {/* Collapse */}
//         <Collapse navbar isOpen={collapseOpen}>
//           {/* Collapse header */}
//           <div className="navbar-collapse-header d-md-none">
//             <Row>
//               {logo ? (
//                 <Col className="collapse-brand" xs="6">
//                   {logo.innerLink ? (
//                     <Link to={logo.innerLink}>
//                       <img alt={logo.imgAlt} src={logo.imgSrc} />
//                     </Link>
//                   ) : (
//                     <a href={logo.outterLink}>
//                       <img alt={logo.imgAlt} src={logo.imgSrc} />
//                     </a>
//                   )}
//                 </Col>
//               ) : null}
//               <Col className="collapse-close" xs="6">
//                 <button
//                   className="navbar-toggler"
//                   type="button"
//                   onClick={toggleCollapse}
//                 >
//                   <span />
//                   <span />
//                 </button>
//               </Col>
//             </Row>
//           </div>
//           {/* Form */}
//           {/* <Form className="mt-4 mb-3 d-md-none">
//             <InputGroup className="input-group-rounded input-group-merge">
//               <Input
//                 aria-label="Search"
//                 className="form-control-rounded form-control-prepended"
//                 placeholder="Search"
//                 type="search"
//               />
//               <InputGroupAddon addonType="prepend">
//                 <InputGroupText>
//                   <span className="fa fa-search" />
//                 </InputGroupText>
//               </InputGroupAddon>
//             </InputGroup>
//           </Form> */}
//           {/* Navigation */}
//           <Nav navbar>{createLinks(routes)}</Nav>
//           {/* Divider */}
//           <hr className="my-3" />
//           {/* Heading */}
//           {/* <h6 className="navbar-heading text-muted">Institucional</h6> */}
//           {/* Navigation */}
//           {/* <Nav className="mb-md-3" navbar>
//             <NavItem>
//               <NavLink href="https://demos.creative-tim.com/argon-dashboard-react/#/documentation/overview?ref=adr-admin-sidebar">
//                 Quem Somos
//               </NavLink>
//             </NavItem>
//             <NavItem>
//               <NavLink href="https://demos.creative-tim.com/argon-dashboard-react/#/documentation/colors?ref=adr-admin-sidebar">
//                 Fale Conosco
//               </NavLink>
//             </NavItem>
//             <NavItem>
//               <NavLink href="https://demos.creative-tim.com/argon-dashboard-react/#/documentation/alerts?ref=adr-admin-sidebar">
//                 FAQ
//               </NavLink>
//             </NavItem>
//             <NavItem>
//               <NavLink href="https://demos.creative-tim.com/argon-dashboard-react/#/documentation/alerts?ref=adr-admin-sidebar">
//                 Política de Privacidade
//               </NavLink>
//             </NavItem>
//             <NavItem>
//               <NavLink href="https://demos.creative-tim.com/argon-dashboard-react/#/documentation/alerts?ref=adr-admin-sidebar">
//                 Termos de Serviço
//               </NavLink>
//             </NavItem>
//           </Nav> */}
//           <div className="sidebar-version" style={{ position: 'relative', textAlign: 'center' }}>
//             <small>Versão: {version}</small>
//           </div>
//         </Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// Sidebar.defaultProps = {
//   routes: [{}],
// };

// Sidebar.propTypes = {
//   // links that will be displayed inside the component
//   routes: PropTypes.arrayOf(PropTypes.object),
//   logo: PropTypes.shape({
//     // innerLink is for links that will direct the user within the app
//     // it will be rendered as <Link to="...">...</Link> tag
//     innerLink: PropTypes.string,
//     // outterLink is for links that will direct the user outside the app
//     // it will be rendered as simple <a href="...">...</a> tag
//     outterLink: PropTypes.string,
//     // the image src of the logo
//     imgSrc: PropTypes.string.isRequired,
//     // the alt for the img
//     imgAlt: PropTypes.string.isRequired,
//   }),
// };

// export default Sidebar;

import { useContext, useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import { AuthContext } from "../../context/AuthContext";
import { version } from "../../version";

const Sidebar = (props: any) => {
  const { handleLogout } = useContext(AuthContext);
  const [collapseOpen, setCollapseOpen] = useState(false);
  const [openSubMenus, setOpenSubMenus] = useState<{ [key: string]: boolean }>({});

  const toggleCollapse = () => {
    setCollapseOpen((data: any) => !data);
  };

  const closeCollapse = (name: string) => {
    if (name === "Sair") {
      handleLogout();
    }
    setCollapseOpen(false);
  };

  const toggleSubMenu = (key: string) => {
    setOpenSubMenus((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const createLinks = (routes: any[]) => {
    return routes.map((prop: any, key: number) => {
      if (prop.subMenu) {
        return (
          <div key={key}>
            <NavItem>
              <NavLink
                href="#submenu"
                onClick={(e) => {
                  e.preventDefault();
                  toggleSubMenu(prop.key);
                }}
              >
                <i className={prop.icon} />
                {prop.name}
              </NavLink>
            </NavItem>
            <Collapse isOpen={openSubMenus[prop.key]}>
              <Nav className="nav-sm flex-column ml-3">
                {prop.subMenu.map((sub: any, subKey: number) => (
                  <NavItem key={subKey}>
                    <NavLink
                      to={sub.layout + sub.path}
                      tag={NavLinkRRD}
                      onClick={() => closeCollapse(sub.name)}
                    >
                      {sub.name}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
            </Collapse>
          </div>
        );
      }

      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={() => closeCollapse(prop.name)}
          >
            <i className={prop.icon} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };

  const { routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>

        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img style={{ width: "100%" }} alt={logo.imgAlt} src={logo.imgSrc} />
          </NavbarBrand>
        ) : null}

        <Collapse navbar isOpen={collapseOpen}>
          <div className="navbar-collapse-header d-md-none">
            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button className="navbar-toggler" type="button" onClick={toggleCollapse}>
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>

          <Nav navbar>{createLinks(routes)}</Nav>

          <hr className="my-3" />

          <div className="sidebar-version" style={{ position: 'relative', textAlign: 'center' }}>
            <small>Versão: {version}</small>
          </div>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
